/**
 * button.js
 */

import React from 'react';
import withStyles from '@mui/styles/withStyles';
import makeStyles from '@mui/styles/makeStyles';
import {
  Button as MuiButton,
} from '@mui/material';
import clsx from 'clsx';
import Spinner from 'components/spinner';


// TODO: rename this to a LoadingButton and remove the custom styling.
// TODO: move text transform styling props to base theme generator.
const StyledButton = withStyles(theme => ({
  root: {}, 
  label: {},
  contained: {
    '&.loading': {
      background: theme.palette.grey.colors[9],
    },
  },
  containedSecondary: {
    '&.loading': {
      background: theme.palette.secondary.colors[7],
    },
  },
  containedPrimary: {
    '&.loading': {
      background: theme.palette.primary.colors[7],
    }
  },
}))(MuiButton);


const useStyles = makeStyles(theme => ({
  noTextTransform: {
    textTransform: 'none',
  },
  loading: {
    pointerEvents: 'none',
  },
  loadingText: {
    color: 'rgba(0,0,0,0.15)',
  },
  loadingContainer: {
    justifyContent: 'center',
  },
  spinner: {
    height: '90%',
    maxHeight: 50,
    width: 'auto',
  }
}));


export default React.forwardRef(function Button(props, ref) {
  const {
    level,
    variant: variantProp,
    color: colorProp,
    children,
    className,
    loading, 
    upperCase: upperCaseProp,
    ...rest
  } = props;
  const classes = useStyles(props);
  const variant = variantProp 
    || (level === 1
      ? 'contained'
      : level === 2
        ? 'outlined'
        : 'text');
  const color = colorProp 
    || (variant === 'contained' ? 'secondary' : 'primary');
  const upperCase = upperCaseProp !== undefined
    ? upperCaseProp
    : variant !== 'contained';


  return (
    <StyledButton 
      classes={{
        root: upperCase ? '' : classes.noTextTransform,
        label: `${classes.label} ${loading ? classes.loadingText : ''}`,
      }}
      className={clsx(className || '', {
        [classes.loading]: loading,
        'loading': loading
      })}
      variant={variant}
      color={color}
      ref={ref}
      {...rest}
    >
      {children}
      {loading && 
      <div className={`absolute-fill flex-hc ${classes.loadingContainer}`}>
        <Spinner className={classes.spinner} />
      </div>}      
    </StyledButton>
  );
})